export const isAbortError = (error: unknown): boolean => {
  return error instanceof DOMException && error.name === 'AbortError';
};

export const addDebouncedFocusVisibleRefetch = (
  refetch: () => void,
  delayMs = 100
): (() => void) => {
  let refetchDebounce: number | undefined;

  const scheduleRefetch = () => {
    if (refetchDebounce != null) {
      window.clearTimeout(refetchDebounce);
    }
    refetchDebounce = window.setTimeout(() => {
      refetchDebounce = undefined;
      refetch();
    }, delayMs);
  };

  const onVisible = () => {
    if (document.visibilityState === 'visible') {
      scheduleRefetch();
    }
  };
  const onFocus = () => {
    scheduleRefetch();
  };

  window.addEventListener('focus', onFocus);
  document.addEventListener('visibilitychange', onVisible);

  return () => {
    if (refetchDebounce != null) {
      window.clearTimeout(refetchDebounce);
    }
    window.removeEventListener('focus', onFocus);
    document.removeEventListener('visibilitychange', onVisible);
  };
};
